/* Scroll reveal.

   Two things this has to get right.

   The hidden state is applied by a class the script adds to <html>, so a
   visitor with JavaScript blocked sees a finished page rather than a column of
   invisible sections.

   And anything already on screen at load is revealed after two animation
   frames, not immediately: adding the class in the same paint that first drew
   the hidden state gives the browser no start value to transition from, so it
   snaps instead of fading. That is why the top of the page never animated
   while the lower sections did.
*/
(function () {
  var root = document.documentElement;
  if (!("IntersectionObserver" in window)) return;
  if (root.classList.contains("bht-js")) return; // the script is on several sections
  root.classList.add("bht-js");

  function show(el, delay) {
    setTimeout(function () { el.classList.add("is-in"); }, delay);
  }

  function watch() {
    var items = Array.prototype.slice.call(
      document.querySelectorAll(".bht-reveal:not(.is-in)")
    );
    if (!items.length) return;

    var fold = window.innerHeight * 0.92;
    var onscreen = [];
    var later = [];
    items.forEach(function (el) {
      if (el.getBoundingClientRect().top < fold) onscreen.push(el);
      else later.push(el);
    });

    // Let the hidden state paint first, then run the entrance in sequence.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        onscreen.forEach(function (el, i) {
          show(el, 80 + i * 90);
        });
      });
    });

    if (!later.length) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var el = e.target;
          show(el, parseInt(el.getAttribute("data-reveal-delay") || "0", 10));
          io.unobserve(el);
        });
      },
      { rootMargin: "0px 0px -8% 0px", threshold: 0.08 }
    );
    later.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState !== "loading") watch();
  else document.addEventListener("DOMContentLoaded", watch);
  document.addEventListener("shopify:section:load", function () {
    root.classList.add("bht-js");
    watch();
  });

  /* Buy buttons.

     The obvious approach — posting the form with return_to=/checkout — hands
     off mid-flight and Shopify frequently lands the shopper on the cart page
     instead, talking about what is already in there. Worse, every press added
     another copy of the subscription to the cart.

     So the cart is emptied, the subscription added, and the browser sent to
     checkout, in that order, with the button held in a working state
     throughout. One subscription, one destination, no cart page.

     If any of it fails the form is submitted normally, which is also what
     happens with JavaScript off: the shopper lands on the cart, which is
     slower but never broken.
  */
  function wireForms() {
    var forms = document.querySelectorAll('.bht form[action*="/cart/add"]:not([data-wired])');
    Array.prototype.forEach.call(forms, function (form) {
      form.setAttribute("data-wired", "1");

      form.addEventListener("submit", function (event) {
        var btn = form.querySelector("button[type=submit]");
        var idInput = form.querySelector("[name=id]");
        if (!window.fetch || !idInput) return; // plain post handles it

        event.preventDefault();
        if (form.dataset.busy === "1") return;
        form.dataset.busy = "1";

        if (btn) {
          btn.dataset.label = btn.textContent.trim();
          btn.textContent = btn.getAttribute("data-busy-label") || "Taking you to checkout…";
          btn.classList.add("is-busy");
          btn.style.pointerEvents = "none";
        }

        var planInput = form.querySelector("[name=selling_plan]");
        var item = { id: Number(idInput.value), quantity: 1 };
        if (planInput && planInput.value) item.selling_plan = Number(planInput.value);

        var json = { "Content-Type": "application/json" };

        // If the redirect has not happened within a few seconds, put the button
        // back. A button stuck on "Taking you to checkout" with nothing
        // happening is the worst of both worlds: it looks broken and it cannot
        // be pressed again.
        var watchdog = setTimeout(function () { restore("Try again"); }, 6000);

        function restore(label) {
          form.dataset.busy = "";
          if (!btn) return;
          btn.textContent = label || btn.dataset.label || "Continue";
          btn.classList.remove("is-busy");
          btn.style.pointerEvents = "";
        }

        // Emptied first so pressing the button twice cannot produce two
        // subscriptions, and so a half-finished earlier visit is not carried in.
        fetch("/cart/clear.js", { method: "POST", headers: json })
          .then(function () {
            return fetch("/cart/add.js", {
              method: "POST",
              headers: json,
              body: JSON.stringify({ items: [item] })
            });
          })
          .then(function (res) {
            if (!res.ok) throw new Error("add failed: " + res.status);
            clearTimeout(watchdog);
            window.location.href = "/checkout";
          })
          .catch(function (err) {
            clearTimeout(watchdog);
            restore();
            // Say something rather than fail silently, then let the browser do
            // it the ordinary way.
            if (console && console.warn) console.warn("[bht] checkout failed:", err);
            form.submit();
          });
      });
    });
  }

  if (document.readyState !== "loading") wireForms();
  else document.addEventListener("DOMContentLoaded", wireForms);
  document.addEventListener("shopify:section:load", wireForms);
})();
